import { useState, useEffect, useMemo } from 'react';
import Loading from '../components/Loading';
import TableCompanyList from '../components/CompanyList/TableCompanyList';
import { Grid, Paper, InputBase, Button } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import '../custom.css';
import CompanyListApi from '../service/company.api';
import { swalClose, swalErrorBtn, swalLoading, swalSuccessTimer } from '../helpers/swalHelper';
import MerchantDialog from '../components/dialogs/company/MerchantDialog';

const CompanyList = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [openDialogMerchant, setOpenDialogMerchant] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [companyListFiltered, setCompanyListFiltered] = useState([]);
  const [isLinearLoading, setIsLinearLoading] = useState(false);

  const handleSearchCompany = () => {
    if (!search) {
      setCompanyListFiltered(companyList);
      return;
    }

    const searchTerm = search.toLowerCase();

    const filtered = companyList.filter((row) => {
      const foundTaxId = row.tax_id && row.tax_id.toLowerCase().includes(searchTerm);
      const foundName = row.name && row.name.toLowerCase().includes(searchTerm);

      return foundTaxId || foundName;
    });

    setCompanyListFiltered(filtered);
  };

  const handleSubmitMerchant = async (data, logoBlob) => {
    try {
      // console.log("Creating merchant:", data);
      await addMerchant(data, logoBlob)
      
      setOpenDialogMerchant(false);
      swalSuccessTimer({ title: `สร้างรายการร้านค้าสำเร็จ ✅` });
      const updatedCompanyList = await getCompanyList();
      setCompanyList(updatedCompanyList);
      setCompanyListFiltered(updatedCompanyList);
    } catch (error) {
      swalErrorBtn({ title: `เกิดข้อผิดพลาด` })
      console.log("Error handleSubmitMerchant:", error);
    }
  };

  const addMerchant = async (data, logoBlob) => {
    try {
      swalLoading({ title: 'กำลังอัพเดทข้อมูล...' })
      const resp = await CompanyListApi.createCompanyApi(data, logoBlob);
      return resp;
    } catch (error) {
      throw new Error(error.message);
    } finally {
      swalClose()
    }
  };

  const getCompanyList = async () => {
    try {
      const resp = await CompanyListApi.getCompanyListApi();
      setCompanyListFiltered(resp.company);
      return resp.company;
    } catch (error) {
      throw new Error(error);
    }
  };

  const handleKeyEnter = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearchCompany();
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      //เรียกAPIและอัพเดทstate
      // setIsLoading(true);
      try {
        setIsLinearLoading(true);
        const data = await getCompanyList(); //รอให้ข้อมูลถูกดึงมาก่อน
        setCompanyList(data); //อัพเดท state companyList ด้วยข้อมูลที่ถูกดึงมา
        setCompanyListFiltered(data);
      } catch (error) {
        console.error(error);
      } finally {
        // setIsLoading(false);
        setIsLinearLoading(false);

      }
    };
    fetchData();
  }, []);

  return (
    <div>
      <Loading isLoading={isLoading} />
      <div className="my-2 ml-2">
        <div className="text-lg font-light flex items-center">
          <div className="py-6 text-xl">รายการร้านค้า</div>
        </div>

        <div>
          <Grid container spacing={1}>
            <Grid item xs={4} md={4} lg={4}>
              <Paper
                component="form"
                sx={{
                  pl: 2,
                  display: 'flex',
                  alignItems: 'center',
                  borderRadius: '20px',
                  justifyContent: 'space-between',
                  boxShadow: 'none',
                  border: '1px solid #CCCCCC',
                }}
              >
                <InputBase
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    // handleSearchCompany(value);
                  }}
                  onKeyDown={handleKeyEnter}
                  fullWidth
                  placeholder="ค้นหา"
                />
                <div className="p-[8px]">
                  <SearchIcon
                    sx={{ fontSize: '22px', mr: 1, color: '#757575' }}
                  />
                </div>
              </Paper>
            </Grid>
            <Grid item xs={3} md={2} lg={1}>
              <div>
                <Button
                  variant="contained"
                  sx={{
                    background: 'primary',
                    color: 'white',
                    borderRadius: '20px',
                  }}
                  onClick={() => handleSearchCompany()}
                >
                  ค้นหา
                </Button>
              </div>
            </Grid>
            <Grid item xs={9} md={3} lg={2}>
              <div>
                <Button
                  variant='contained'
                  sx={{ background: 'primary', color: 'white', borderRadius: '20px' }}
                  onClick={() => setOpenDialogMerchant(true)}
                >
                  เพิ่มร้านค้า
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>

      <MerchantDialog
        open={openDialogMerchant}
        onClose={() => setOpenDialogMerchant(false)}
        mode="create"
        onSubmit={handleSubmitMerchant}
      />

      <Grid>
        <Grid>
          <TableCompanyList
            companyList={companyListFiltered}
            getCompanyList={getCompanyList}
            isLinearLoading={isLinearLoading}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default CompanyList;